export const SECTION_ERROR_LINE =
  'There are one or more errors in this section. Please check the form and try again.';
